// extracted by mini-css-extract-plugin
export var active = "_i6-7";
export var blink = "_i6-8";
export var dropDownSelector = "_i6-4";
export var dropDownWrapper = "_i6-3";
export var fakeCursor = "_i6-6";
export var fontSizeButton = "_i6-9";
export var formQuillEditor = "_i6-0";
export var pressed = "_i6-a";
export var qlBlank = "_i6-1";
export var textFormattingToolbar = "_i6-2";
export var textToolbarOption = "_i6-5";